


const SITE_SECTION = 'kpf:gift:b2c';
const SUB_SECTION = 'subsection';
const PAGE_IDENTIFIER = 'pageidentifier';
const CATEGORY = 'category';
const HOME = 'home';
const BRAND = 'brand';
const PREVIOUS_PAGENAME_REQUIRED = [HOME, CATEGORY, BRAND];
const PREVIOUS_PAGE = 'previousPage';
const GIFT_CARDS = 'gift-cards';
const PRODUCT = 'product';

const getSubSection = (subSection) => {
    return subSection === GIFT_CARDS ? PRODUCT : subSection;
}

const getStringFromPath = (pathname, item) => {
    const pathArr = pathname.split('/')
    if(item === SUB_SECTION) {
        if (pathArr.length > 2) {
            return pathArr.slice(1, pathArr.length - 1).join(':');
        }
        return pathArr[1] === '' ? HOME : pathArr[1];
    }
    if(item === PAGE_IDENTIFIER) {
        return pathArr.length > 2 ? pathArr[pathArr.length - 1] : '';
    }
    return '';
}

export const setPreviousPage = (pathname = window.location.pathname) => {
    const subSection = getStringFromPath(pathname, SUB_SECTION);
    if (PREVIOUS_PAGENAME_REQUIRED.includes(subSection)) {
        const pageIdentifier = getStringFromPath(pathname, PAGE_IDENTIFIER);
        window.localStorage.setItem(PREVIOUS_PAGE, `${subSection} ${pageIdentifier}`);
    } else if  (GIFT_CARDS !== subSection){
        window.localStorage.removeItem(PREVIOUS_PAGE);
    }
}

export const getPreviousPage = () => {
    const previousPage = window.localStorage.getItem(PREVIOUS_PAGE);
    if (previousPage) {
        return `${SITE_SECTION}:${previousPage}`;
    }
    return undefined;
}

const getPageName = (pathname, siteSection) => {
    const subSection = getSubSection(getStringFromPath(pathname, SUB_SECTION));
    const pageIdentifier = getStringFromPath(pathname, PAGE_IDENTIFIER)
    return `${siteSection}:${subSection} ${pageIdentifier}`.trim().toLowerCase()
}

const getSubSectionName = (pathname, siteSection) => {
    const subSectionName = getSubSection(getStringFromPath(pathname, SUB_SECTION));
    return `${siteSection}:${subSectionName}`;
}

// fetching banner name from subcompany stored in cookies
const getBanner = () => {
    const cookiesArray = document.cookie.split(';')
    const cookiePairArr = cookiesArray.filter((pair) => {
        return pair.includes('subcompany=')
    });
    // need to make this independant of Kroger
    return cookiePairArr.length ? cookiePairArr[0].split('=')[1] : 'kroger';
}


const getLoginStatus = () => {
    return window.localStorage.getItem('login_status') || 'false';
}

const getQueryParam = (param) => {
    const params = new URLSearchParams(window.location.search)
    if(param === 'campaign'){
        return params.has('cid') ? params.get('cid') : ''
    }
    if(param === 'internal_campaign'){
        return params.has('icid') ? params.get('icid') : ''
    }
    return '';
}

export const globalProperties = (pathname = window.location.pathname) => {
    return {
        pageName: getPageName(pathname, SITE_SECTION),
        section: SITE_SECTION,
        subSection: getSubSectionName(pathname, SITE_SECTION),
        url: window.location.href,
        referrer: document.referrer,
        banner: getBanner(),
        campaign: getQueryParam('campaign'),
        internal_campaign: getQueryParam('internal_campaign'),
        login_status: getLoginStatus(),
        platform: 'web'
    }
}

export const getProductDetails = (lineItems) => {
    return lineItems.map(product => {
        return {
            product_id: product.product.universalProductCode,
            sku: product.faceplate.code,
            name: product.name,
            brand: product.product.brandName,
            price: product.amount,
            quantity: product.quantity,
            image_url: product.faceplate.imageURL,
        }
    });
}

export const isAllCookiesAllowed = () => {
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');
    let allowAllCookies = false;
    for (let i = 0; i < cookies.length; i++) {
        allowAllCookies = allowAllCookies || cookies[i].trim().includes('cmapi_cookie_privacy=permit 1,2,3');
    }
    return allowAllCookies;
}
